(function(){
  function init(root){
    if(!root||root.getAttribute('data-jcp-initialized')==='true')return;
    root.setAttribute('data-jcp-initialized','true');
    if(root.querySelector('.jcp-success'))return;

    var tabs=root.querySelectorAll('[data-jcp-tab]');
    var panels=root.querySelectorAll('[data-jcp-panel]');
    var path=root.querySelector('[data-jcp-path]');
    var builtCross=root.querySelector('[data-jcp-built-cross]');
    var collabPairing=root.querySelector('[data-jcp-collab-pairing]');
    var crossSummary=root.querySelector('[data-jcp-cross-summary]');
    var collabSummary=root.querySelector('[data-jcp-collab-summary]');
    var parents=root.querySelectorAll('[data-jcp-parent]');
    var collabSelect=root.querySelector('[data-jcp-collab-parent]');
    var collabCustomWrap=root.querySelector('[data-jcp-collab-custom-wrap]');
    var collabCustom=root.querySelector('[data-jcp-collab-custom]');
    var yourPlant=root.querySelector('[data-jcp-your-plant]');
    var hybridGoal=root.querySelector('[name="contact[Hybrid Goal]"]');
    var collabWhy=root.querySelector('[name="contact[Why Collaborate]"]');
    var submit=root.querySelector('[data-jcp-submit]');
    var form=root.querySelector('form');
    var currentMode='hybrid';

    function safeGet(key){try{return sessionStorage.getItem(key);}catch(e){return null;}}
    function safeSet(key,value){try{sessionStorage.setItem(key,value);}catch(e){}}
    function safeRemove(key){try{sessionStorage.removeItem(key);}catch(e){}}

    function parentValue(which){
      var select=root.querySelector('[data-jcp-parent="'+which+'"]');
      var custom=root.querySelector('[data-jcp-custom="'+which+'"]');
      if(!select)return'';
      return select.value==='__custom__'?(custom&&custom.value.trim()?custom.value.trim():'Custom parent'):select.value;
    }

    function updateCross(){
      var one=parentValue('1'),two=parentValue('2');
      var text=one&&two?one+' × '+two:'Choose two parents to build the cross.';
      if(crossSummary)crossSummary.textContent=text;
      if(builtCross)builtCross.value=one&&two?text:'';
    }

    function updateCustom(which){
      var select=root.querySelector('[data-jcp-parent="'+which+'"]');
      var wrap=root.querySelector('[data-jcp-custom-wrap="'+which+'"]');
      var custom=root.querySelector('[data-jcp-custom="'+which+'"]');
      if(!select||!wrap||!custom)return;
      var show=select.value==='__custom__';
      wrap.hidden=!show;
      custom.disabled=!show||select.disabled;
      custom.required=show&&!select.disabled;
      if(!show)custom.value='';
      updateCross();
    }

    function collabParentValue(){
      if(!collabSelect)return'';
      return collabSelect.value==='__custom__'?(collabCustom&&collabCustom.value.trim()?collabCustom.value.trim():'Custom Jiggy parent'):collabSelect.value;
    }

    function updateCollab(){
      var jiggyParent=collabParentValue();
      var plant=yourPlant&&yourPlant.value.trim()?yourPlant.value.trim():'';
      var text=jiggyParent&&plant?jiggyParent+' × '+plant:'Choose a Jiggy parent and tell me what plant you’re bringing.';
      if(collabSummary)collabSummary.textContent=text;
      if(collabPairing)collabPairing.value=jiggyParent&&plant?text:'';
    }

    function updateCollabCustom(){
      if(!collabSelect||!collabCustomWrap||!collabCustom)return;
      var show=collabSelect.value==='__custom__';
      collabCustomWrap.hidden=!show;
      collabCustom.disabled=!show||collabSelect.disabled;
      collabCustom.required=show&&!collabSelect.disabled;
      if(!show)collabCustom.value='';
      updateCollab();
    }

    function setPanel(mode){
      currentMode=mode==='collab'?'collab':'hybrid';
      tabs.forEach(function(tab){tab.setAttribute('aria-selected',tab.getAttribute('data-jcp-tab')===currentMode?'true':'false');});
      panels.forEach(function(panel){
        var active=panel.getAttribute('data-jcp-panel')===currentMode;
        panel.hidden=!active;
        panel.querySelectorAll('input,select,textarea').forEach(function(field){field.disabled=!active;});
      });
      if(path)path.value=currentMode==='collab'?'Request a Collab':'Build a Hybrid';
      if(submit)submit.textContent=currentMode==='collab'?'REQUEST THE COLLAB →':'SEND MY PULSE →';
      if(currentMode==='collab'){
        updateCollabCustom();
        updateCollab();
      }else{
        updateCustom('1');
        updateCustom('2');
        updateCross();
      }
    }

    tabs.forEach(function(tab){tab.addEventListener('click',function(){setPanel(tab.getAttribute('data-jcp-tab'));});});
    parents.forEach(function(select){
      var which=select.getAttribute('data-jcp-parent');
      select.addEventListener('change',function(){updateCustom(which);updateCross();});
    });
    root.querySelectorAll('[data-jcp-custom]').forEach(function(input){input.addEventListener('input',updateCross);});
    if(collabSelect)collabSelect.addEventListener('change',function(){updateCollabCustom();updateCollab();});
    if(collabCustom)collabCustom.addEventListener('input',updateCollab);
    if(yourPlant)yourPlant.addEventListener('input',updateCollab);
    if(form)form.addEventListener('submit',function(){
      safeSet('jcpLastPath',currentMode);
      var pairing=currentMode==='collab'?(collabPairing&&collabPairing.value?collabPairing.value:''):(builtCross&&builtCross.value?builtCross.value:'');
      var note=currentMode==='collab'?(collabWhy&&collabWhy.value?collabWhy.value.trim():''):(hybridGoal&&hybridGoal.value?hybridGoal.value.trim():'');
      if(pairing)safeSet('jcpLastPairing',pairing);else safeRemove('jcpLastPairing');
      if(note)safeSet('jcpLastNote',note);else safeRemove('jcpLastNote');
    });

    var resetMode=safeGet('jcpResetMode');
    if(resetMode)safeRemove('jcpResetMode');
    setPanel(resetMode==='collab'?'collab':'hybrid');
    if(resetMode&&window.location.hash==='#collector-pulse'){
      window.setTimeout(function(){root.scrollIntoView({behavior:'smooth',block:'start'});},30);
    }
  }

  document.querySelectorAll('[data-jcp-root]').forEach(init);
})();

(function(){
  function ensureKeyframes(){
    if(document.getElementById('jcg-loop-fix-keyframes'))return;
    var style=document.createElement('style');
    style.id='jcg-loop-fix-keyframes';
    style.textContent='@keyframes jcg-loop-fixed{from{transform:translate3d(0,0,0)}to{transform:translate3d(var(--jcg-loop-distance),0,0)}}';
    document.head.appendChild(style);
  }

  function initGrowoutLoop(root){
    if(!root||root.getAttribute('data-jcg-loop-fixed')==='true')return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

    var carousel=root.querySelector('.jcg-carousel');
    var track=root.querySelector('.jcg-track');
    if(!carousel||!track)return;

    var sets=track.querySelectorAll('.jcg-set');
    if(sets.length<2)return;

    var primary=sets[0];
    var template=sets[1];
    root.setAttribute('data-jcg-loop-fixed','true');
    ensureKeyframes();

    function normalizeSet(set){
      set.style.flex='0 0 auto';
    }

    function rebuild(){
      track.querySelectorAll('[data-jcg-auto-clone="true"]').forEach(function(clone){clone.remove();});
      normalizeSet(primary);
      normalizeSet(template);

      var setWidth=primary.getBoundingClientRect().width;
      var viewportWidth=carousel.getBoundingClientRect().width;
      if(!setWidth||!viewportWidth)return;

      track.style.setProperty('--jcg-loop-distance','-'+setWidth+'px');
      track.style.animationName='jcg-loop-fixed';

      var targetWidth=setWidth+viewportWidth+32;
      var guard=0;
      while(track.scrollWidth<targetWidth&&guard<12){
        var clone=template.cloneNode(true);
        clone.setAttribute('data-jcg-auto-clone','true');
        clone.setAttribute('aria-hidden','true');
        normalizeSet(clone);
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){el.setAttribute('tabindex','-1');});
        track.appendChild(clone);
        guard++;
      }
    }

    rebuild();
    var timer;
    window.addEventListener('resize',function(){
      window.clearTimeout(timer);
      timer=window.setTimeout(rebuild,120);
    });
    if('ResizeObserver'in window){
      var observer=new ResizeObserver(function(){
        window.clearTimeout(timer);
        timer=window.setTimeout(rebuild,60);
      });
      observer.observe(carousel);
      observer.observe(primary);
    }
  }

  function boot(scope){
    (scope||document).querySelectorAll('.jcg').forEach(initGrowoutLoop);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);

  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();